import tokens from '@ifood/pomodoro-tokens';
import { createGlobalStyle } from 'styled-components';

import Anchor from 'images/anchor.svg';

const anchorImgSize = 16;

export const HeadingStyles = createGlobalStyle`
  .heading-link {
    position: relative;
    cursor: pointer;

    &:hover {
      @media (min-width: ${tokens.breakpoints.s}) {
        &:before {
          position: absolute;
          top: calc(50% - ${anchorImgSize / 2}px);
          left: -25px;
          width: ${anchorImgSize}px;
          height: ${anchorImgSize}px;
          content: ' ';
          display: block;
          background-image: url(${Anchor});
        }
      }
    }
  }
`;
